'use client';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

const industries = [
    { value: 'technology', label: 'Technology & Software' },
    { value: 'finance', label: 'Finance & Banking' },
    { value: 'healthcare', label: 'Healthcare & Life Sciences' },
    { value: 'retail', label: 'Retail & E-commerce' },
    { value: 'manufacturing', label: 'Manufacturing & Industrial' },
    { value: 'education', label: 'Education & EdTech' },
    { value: 'media', label: 'Media & Entertainment' },
    { value: 'consulting', label: 'Consulting & Professional Services' },
    { value: 'real_estate', label: 'Real Estate & Construction' },
    { value: 'automotive', label: 'Automotive & Transportation' },
    { value: 'telecom', label: 'Telecommunications' },
    { value: 'energy', label: 'Energy & Utilities' },
    { value: 'agriculture', label: 'Agriculture & Farming' },
    { value: 'hospitality', label: 'Hospitality & Tourism' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'nonprofit', label: 'Nonprofit & NGO' },
    { value: 'government', label: 'Government & Public Sector' },
    { value: 'aerospace', label: 'Aerospace & Defense' },
    { value: 'pharma', label: 'Pharmaceuticals' },
    { value: 'consumer_goods', label: 'Consumer Goods & FMCG' },
    { value: 'logistics', label: 'Logistics & Supply Chain' },
    { value: 'legal', label: 'Legal Services' },
    { value: 'marketing', label: 'Marketing & Advertising' },
    { value: 'gaming', label: 'Gaming & Esports' },
    { value: 'cybersecurity', label: 'Cybersecurity' },
] as const;

interface IndustrySelectProps {
    value?: string;
    onChange?: (value: string) => void;
}

export function IndustrySelect({ value, onChange }: IndustrySelectProps) {
    return (
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger>
                <SelectValue placeholder="Select industry" />
            </SelectTrigger>
            <SelectContent className="max-h-[300px]">
                {industries.map((industry) => (
                    <SelectItem key={industry.value} value={industry.value}>
                        {industry.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
